export const TYPE_CLASS_NAMES = {
  warning: 'br-banner-warning',
  danger: 'br-banner-danger',
  success: 'br-banner-success',
  info: 'br-banner-info',
  teal: 'br-banner-teal'
};
